module.exports = __webpack_public_path__ + "img/link-logo.7502c035.png";